import { Navigate } from 'react-router-dom'
import { useProjectId } from '../../../hooks/useProjectId'
import { MasterSurveyPage } from '../MultiMarket/MasterSurveyPage'
import { WaveFlowBreadcrumb } from './WaveFlowBreadcrumb'
import { useWaveId } from './useWaveId'
import { useWaves } from './useWaves'

/**
 * The questionnaire editor scoped to this wave's markets, so it locks when this
 * wave starts fielding rather than when any wave does.
 */
export const WaveSurveyPage = () => {
  const projectId = useProjectId()
  const waveId = useWaveId()
  const { waves, loading } = useWaves(projectId)
  const wave = waves.find((candidate) => candidate.waveId === waveId)

  if (loading) {
    return null
  }

  if (!wave) {
    return <Navigate to={`/project/${projectId}`} replace />
  }

  return (
    <>
      <WaveFlowBreadcrumb activeStep="Survey" />
      <MasterSurveyPage markets={wave.surveys} />
    </>
  )
}
